/*
 * @description: 确认订单页派车要求
 */
import type { FavDriversType } from '@/pages/order-center/type';
import { useState, useCallback } from 'react';

type setDataType = {
  favDrivers?: FavDriversType;
  sendType?: number;
};

export default function OrderCenterSameCityDeliveryCarRequire() {
  // 订单备注下拉选择
  const [sendDriverFids, setSendDriverFids] = useState<string[]>([]);
  const [sendType, setSendType] = useState<number>(0);
  const setSendDriverFidsM = useCallback((val) => {
    setSendDriverFids(val);
  }, []);
  const setSendTypeCb = useCallback((val) => {
    setSendType(val);
  }, []);

  // 更新所有数据
  const set = useCallback((val?: setDataType) => {
    const sendDriverFidsLocal = (val?.favDrivers || []).map(
      (item) => item.driverFid
    );
    setSendType(val?.sendType || 0);
    setSendDriverFidsM(sendDriverFidsLocal);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //  清空数据
  const reset = useCallback(() => {
    setSendDriverFidsM([]);
    setSendType(0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    sendDriverFids,
    setSendDriverFidsM,
    sendType,
    setSendTypeCb,
    set,
    reset,
  };
}
